/* eslint-disable no-sequences */
const ie = () => {
  let undef;
  let v = 3;
  const div = document.createElement('div');
  const all = div.getElementsByTagName('i');

  while (
    div.innerHTML = '<!--[if gt IE ' + (++v) + ']><i></i><![endif]-->',
    all[0]
  );

  return v > 4 ? v : undef;
};

export default ie;
